import { Link } from "react-router-dom";
import { UserPlus, ExternalLink, ShieldCheck } from "lucide-react";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { SITE_REGISTER_URL } from "@/lib/api";

export default function Register() {
  return (
    <AuthLayout
      title="Create Account"
      subtitle="Join the oldest Indian virtual airline and get your callsign."
      footer={
        <>
          Already a pilot?{" "}
          <Link to="/login" data-testid="register-to-login-link" className="font-semibold text-[#D4AF37] hover:underline">
            Log In
          </Link>
        </>
      }
    >
      <div className="space-y-6" data-testid="register-panel">
        <p className="text-sm leading-relaxed text-[#A1A1AA]">
          New pilot registration is handled securely on our main crew portal.
          Create your account there to receive your callsign and API key, then
          sign in here to access your dashboard.
        </p>

        <div className="space-y-3 rounded-xl border border-white/10 bg-white/[0.02] p-4">
          {[
            "Get your official Air India Virtual callsign",
            "Access the fleet, routes and file PIREPs",
            "Receive your API key to log in here",
          ].map((t) => (
            <div key={t} className="flex items-start gap-3 text-sm text-[#FDFBF7]">
              <ShieldCheck className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#D4AF37]" />
              <span>{t}</span>
            </div>
          ))}
        </div>

        <a
          href={SITE_REGISTER_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="register-portal-btn"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-[#8A1538] px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#A81A45]"
        >
          <UserPlus className="h-4 w-4" />
          Register on the Crew Portal
          <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </AuthLayout>
  );
}
